(() => {
 if (window.swStorefrontReady) return;
 window.swStorefrontReady = true;
 const triggers = new WeakMap();
 const ratios = new WeakMap();
 const dialogs = '[data-sw-menu-dialog], [data-sw-search-dialog]';
 let observer, sceneNav;
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const lock = () => document.documentElement.classList.toggle('sw-lock-scroll', !!document.querySelector('dialog.sw[open]'));
 const close = dialog => { if (dialog?.open) dialog.close(); };
 function open(dialog, trigger) {
  if (!dialog?.showModal) return;
  document.querySelectorAll(dialogs).forEach(other => { if (other !== dialog) close(other); });
  triggers.set(dialog, trigger);dialog.showModal();trigger?.setAttribute('aria-expanded','true');lock();
  if (dialog.matches('[data-sw-search-dialog]')) dialog.querySelector('input[type=search]')?.focus();
 }
 function setVideoButton(video) {
  const button = video.closest('[data-sw-scene]')?.querySelector('[data-sw-video-toggle]');
  if (!button) return;
  button.hidden = false;
  button.textContent = video.paused ? 'Play video' : 'Pause video';
  button.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
  button.setAttribute('aria-pressed',String(video.paused));
 }
 function scenes() {
  observer?.disconnect();sceneNav?.remove();
  const all = [...document.querySelectorAll('[data-sw-scene]')];
  if (!all.length) return;
  sceneNav = document.createElement('nav');sceneNav.className = 'sw-scene-nav';sceneNav.setAttribute('aria-label','Homepage collections');
  all.forEach((scene,index) => {
   scene.id ||= `SWScene-${index}`;
   const link = document.createElement('a');link.href = `#${scene.id}`;link.setAttribute('aria-label',scene.dataset.swLabel || `Collection ${index + 1}`);
   const label = document.createElement('span');label.textContent = scene.dataset.swLabel || `Collection ${index + 1}`;link.append(label);sceneNav.append(link);
  });
  document.body.append(sceneNav);
  observer = new IntersectionObserver(entries => {
   entries.forEach(entry => ratios.set(entry.target,entry.intersectionRatio));
   const active = all.reduce((best,scene) => (ratios.get(scene) || 0) > (ratios.get(best) || 0) ? scene : best,all[0]);
   sceneNav.querySelectorAll('a').forEach(a => a.setAttribute('aria-current',String(a.hash === `#${active.id}`)));
   sceneNav.classList.toggle('sw-nav-hidden',!all.some(scene => (ratios.get(scene) || 0) > .1));
  },{threshold:[0,.1,.25,.5,.75,1]});
  all.forEach(scene => observer.observe(scene));
 }
 function bind(scope) {
  scope.querySelectorAll(dialogs).forEach(dialog => {
   if (dialog.dataset.swBound) return;dialog.dataset.swBound = 'true';
   dialog.addEventListener('close',() => {const trigger = triggers.get(dialog);trigger?.setAttribute('aria-expanded','false');lock();if (trigger?.isConnected) trigger.focus();});
  });
  scope.querySelectorAll('.sw-hero video').forEach(video => {
   if (video.dataset.swBound) return;video.dataset.swBound = 'true';
   video.addEventListener('play',() => setVideoButton(video));video.addEventListener('pause',() => setVideoButton(video));video.addEventListener('loadeddata',() => setVideoButton(video));
   if (reduced.matches) video.pause();
   setVideoButton(video);
  });
 }
 document.addEventListener('click',event => {
  const trigger = event.target.closest('[data-sw-open-menu], [data-sw-open-search]');
  if (trigger) {const header = trigger.closest('[data-sw-header]');open(header?.querySelector(trigger.hasAttribute('data-sw-open-menu') ? '[data-sw-menu-dialog]' : '[data-sw-search-dialog]'),trigger);}
  if (event.target.closest('[data-sw-close-dialog]')) close(event.target.closest('dialog'));
  if (event.target.matches('dialog.sw')) {const rect = event.target.getBoundingClientRect();if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(event.target);}
  const videoButton = event.target.closest('[data-sw-video-toggle]');
  if (videoButton) {const video = videoButton.closest('[data-sw-scene]').querySelector('video');if (video) {video.dataset.swUserPaused = String(!video.paused);if (video.paused) video.play().catch(() => {});else video.pause();}}
  const next = event.target.closest('[data-sw-next]');
  if (next) {event.preventDefault();const all = [...document.querySelectorAll('[data-sw-scene]')];const index = all.indexOf(next.closest('[data-sw-scene]'));const target = all[index+1] || document.querySelector('.sw-promo,.sw-footer');target?.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'});}
  document.querySelectorAll('.sw-desktop-nav details[open]').forEach(details => {if (!details.contains(event.target)) details.open = false;});
 });
 document.addEventListener('keydown',event => {if (event.key === 'Escape') document.querySelectorAll('.sw-nav-details[open]').forEach(details => {details.open = false;});});
 function scrollHeader() {const wrapper = document.querySelector('.page-wrapper');const top = Math.max(window.scrollY,wrapper?.scrollTop || 0);document.querySelectorAll('[data-sw-header]').forEach(header => header.classList.toggle('sw-is-scrolled',top > 30));}
 window.addEventListener('scroll',scrollHeader,{passive:true});document.querySelector('.page-wrapper')?.addEventListener('scroll',scrollHeader,{passive:true});
 document.addEventListener('shopify:section:load',event => {bind(event.target);scenes();scrollHeader();});
 document.addEventListener('shopify:section:reorder',scenes);
 document.addEventListener('shopify:section:unload',() => queueMicrotask(() => {lock();scenes();}));
 document.addEventListener('shopify:section:select',event => {event.target.querySelector('[data-sw-scene]')?.scrollIntoView({behavior:'instant',block:'center'});});
 reduced.addEventListener('change',event => document.querySelectorAll('.sw-hero video').forEach(video => {if (event.matches) video.pause();else if (video.dataset.swUserPaused !== 'true') video.play().catch(() => {});}));
 bind(document);scenes();scrollHeader();
})();
